import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/styles';
import validator from '@trialbee/eligibility-validator';
import classNames from 'classnames';
import 'core-js/features/object/entries';
import 'core-js/features/object/from-entries';
import React, { forwardRef, useState } from 'react';
import PropTypes, { consentPropType } from '../../helpers/propTypes';
import { userMetrics } from '../../userMetrics';
import ConsentItem from './Item';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '8px 16px',
    backgroundColor: theme.palette.grey[50],
    marginBottom: theme.spacing(2),
  },

  error: {
    borderColor: theme.palette.error.main,
  },
}));

function getKeyIdMap(questions) {
  return Object.fromEntries(questions.map(({ key, id }) => [key, id]));
}

function mapAnswers(answers, questions) {
  const keyIdMap = getKeyIdMap(questions);
  return Object.entries(answers).map(([key, answer]) => ({
    questionId: keyIdMap[key],
    answer,
  }));
}

const Consent = forwardRef(
  (
    { consent: { questions, criteria }, error, handleConsent, openTerms },
    ref,
  ) => {
    const classes = useStyles();
    const [answers, setAnswers] = useState(
      questions
        .filter((q) => q?.type !== 'yesno')
        .reduce((acc, { key }) => ({ ...acc, [key]: 'false' }), {}),
    );

    const getAnswer = (key) => answers[key];
    const setAnswer = (key, answer) => {
      const newAnswers = { ...answers, [key]: answer };
      setAnswers(newAnswers);

      const { eligible: valid } = validator(criteria, newAnswers, questions);
      const mappedAnswers = mapAnswers(newAnswers, questions);
      handleConsent({ valid, answers: mappedAnswers });
    };

    return (
      <Grid ref={ref} item xs={12}>
        <Paper
          className={classNames(classes.root, {
            [classes.error]: Boolean(error),
          })}
          variant="outlined"
        >
          {questions.map((question) => (
            <ConsentItem
              key={question.id}
              answer={getAnswer(question.key)}
              openTerms={openTerms}
              question={question}
              setAnswer={(answer) => {
                userMetrics.track('Contact info button clicked consent', {
                  answer,
                });
                setAnswer(question.key, answer);
              }}
            />
          ))}
        </Paper>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </Grid>
    );
  },
);

Consent.propTypes = {
  consent: consentPropType.isRequired,
  error: PropTypes.string,
  handleConsent: PropTypes.func.isRequired,
  openTerms: PropTypes.func.isRequired,
};

Consent.defaultProps = {
  error: undefined,
};

export default Consent;
